import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsArticleGroup, UpdateNewsArticleGroupRequest } from '@models/news-article-group';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NewsArticleGroupsService {
  private readonly url = `${environment.bffUrl}/news-groups`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<NewsArticleGroup[]> {
    return this.httpClient.get<NewsArticleGroup[]>(this.url);
  }

  getOne(id: string): Observable<NewsArticleGroup> {
    return this.httpClient.get<NewsArticleGroup>(`${this.url}/${id}`);
  }

  update(id: string, req: UpdateNewsArticleGroupRequest): Observable<NewsArticleGroup> {
    return this.httpClient.put<NewsArticleGroup>(`${this.url}/${id}`, req);
  }

  setWorkloads(id: string, req: string[]): Observable<NewsArticleGroup> {
    return this.httpClient.post<NewsArticleGroup>(`${this.url}/${id}/set-workloads`, req);
  }

  setMembershipLevels(id: string, req: string[]): Observable<NewsArticleGroup> {
    return this.httpClient.post<NewsArticleGroup>(`${this.url}/${id}/set-membership-levels`, req);
  }

  addFieldExpert(id: string, fieldExpertId: string): Observable<NewsArticleGroup> {
    return this.httpClient.post<NewsArticleGroup>(`${this.url}/${id}/field-experts`, { fieldExpertId });
  }

  deleteFieldExpert(id: string, fieldExpertId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${id}/field-experts/${fieldExpertId}`);
  }
}
